<div class="container">
  <div class="modal-header">
    <h5 class="modal-title">{{ data.titolo }}</h5>
  </div>

  <p class="my-3">{{ data.messaggio }}</p>

  <div class="elenco-collegamenti">
    <div class="sezione" *ngFor="let sezione of data.sezioni">
      <div class="sezione-titolo">{{ sezione.titolo }} ({{ totaleVoci(sezione) }})</div>
      <small class="sezione-suggerimento">{{ sezione.suggerimento }}</small>

      <div class="gruppo" *ngFor="let gruppo of sezione.gruppi">
        <div class="gruppo-etichetta" *ngIf="gruppo.etichetta">{{ gruppo.etichetta }} ({{ gruppo.voci.length }})</div>
        <ul>
          <li *ngFor="let voce of gruppo.voci">{{ voce }}</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button mat-raised-button color="primary" type="button" (click)="chiudi()">
      {{ 'map.sidebar.psa.delete_blocked.close' | translate }}
    </button>
  </div>
</div>
